import type { MobileTopNavProps } from "@circleco/compass/components/MobileTopNav";
import { MobileTopNav } from "@circleco/compass/components/MobileTopNav";
import { useEffect } from "react";

import { useMobileChromeVisibility } from "@/react/components/Mobile/hooks/chrome/useMobileChromeVisibility";
import { primaryActionToneFix } from "@/react/components/Mobile/shell/topBar/mobileTopBarTokens";

/**
 * `MobileTopNav`, permanently shadowing `MobileShell.Header`'s badge-color
 * remap back to Compass's own un-remapped values (`primaryActionToneFix`) -
 * for TopBars that must never pick up the community's branding.
 *
 * Drop-in replacement for `MobileTopNav` at those call sites.
 *
 * Also flips `isTopBarUnbranded` (ref-counted, see `ChromeVisibilityContext`)
 * on while mounted, off on unmount. That flag - not this component's own
 * `themeVars` - is what `MobileShellInner` and `MobileSectionTabs` check to
 * skip *their own*, separate remaps.
 */
export const UnthemedMobileTopNav = ({
  themeVars,
  ...props
}: MobileTopNavProps) => {
  const { setIsTopBarUnbranded } = useMobileChromeVisibility();

  useEffect(() => {
    setIsTopBarUnbranded(true);
    return () => setIsTopBarUnbranded(false);
  }, [setIsTopBarUnbranded]);

  return (
    <MobileTopNav
      {...props}
      themeVars={{ ...themeVars, ...primaryActionToneFix }}
    />
  );
};
